module.exports = __webpack_public_path__ + "img/plus.61791b11.svg";